// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * PartitionKey Definition Version
 */
export enum PartitionKeyDefinitionVersion {
  V1 = 1,
  V2 = 2,
}
